import {
    tns
} from 'tiny-slider/src/tiny-slider';

const sliderConfig = require('./sliderConfig').sliderConfig

export const start = async function(id) {
    await setTimeout(async () => {
        var updateConfig = sliderConfig;
        sliderConfig.container = `.base-full-carouselGalleryContainer_${id}`
        var slider = tns(updateConfig);

        console.log("carouselGalleryContainer_${id}", `carouselGalleryContainer_${id}`)
        let arrowContainer = document.getElementById(`carouselGalleryContainer_${id}`);


        updateInfos({
                displayIndex: 1,
            },
            arrowContainer,
            id);

        slider.events.on('transitionEnd', (e) => updateInfos(e, arrowContainer, id));

        let next = arrowContainer.getElementsByClassName("right");
        let prev = arrowContainer.getElementsByClassName("left");

        next[0].addEventListener('click', (e) => slider.goTo('next'));
        prev[0].addEventListener('click', (e) => slider.goTo('prev'));

        Array.from(document.querySelectorAll(`[openCaroucelItem_${id}`)).forEach((caroucelItem) => {
            caroucelItem.addEventListener('click', (_e) => openSlider(caroucelItem, slider, id, arrowContainer))
        })

        let close = document.getElementById(`closeBtn_${id}`);

        close.addEventListener('click', (e) => closeSlider(id));

    }, 100)

    function updateInfos(e, container, id) {

        const dots = Array.from(container.getElementsByClassName("dot"))

        const containerItems = Array.from(document.getElementById(`base-full-carouselGalleryContainer_${id}`).getElementsByClassName("item"));

        dots.forEach((dot, i) => {
            if ((i + 1) == e.displayIndex) {
                dot.classList.add("active")
                containerItems[i].classList.add("active")
            } else {
                dot.classList.remove("active")
                containerItems[i].classList.remove("active")
            }
        })
    }

    async function openSlider(e, slider, id, arrowContainer) {
        const photoId = e.getAttribute(`opencaroucelitem_${id}`)

        await slider.goTo(photoId)
        await updateInfos({
            displayIndex: photoId
        }, arrowContainer, id);

        const fullScreenImage = document.getElementById(`fullScreenImage_${id}`);

        fullScreenImage.classList.add("opened");
        document.body.style.overflow = "hidden";

    }

    async function closeSlider(id) {
        const fullScreenImage = document.getElementById(`fullScreenImage_${id}`);
        fullScreenImage.classList.remove("opened");
        document.body.style.overflow = "auto";
    }
}

export const stop = async function() {
    var slider = tns(sliderConfig);
    await slider.destroy();
    return true;
}
